import React, {createContext, useContext, useState} from "react";

const URLContext = createContext({pageUrl: "", setPageUrl: () => {}});

const PageURLContextProvider = ({children}) => {
  const [pageUrl, setPageUrl] = useState("");

  const contextValue = {pageUrl, setPageUrl};

  return <URLContext.Provider value={contextValue}>{children}</URLContext.Provider>;
};

export default PageURLContextProvider;

export const usePageURLContext = () => {
  const context = useContext(URLContext);
  return context;
};
